import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        user: '<',
        activeSkill: '<',
        userSkills: '<'
    },
    template: `
        <div class="modal-header">
            <div class="heading01 heading01b">
                <h2>{{ 'user.Skill' | translate }}</h2>
                <ul class="actions01">
                    <li class="primary">
                        <button class="btn main" type="button"
                            ng-click="vm.save()" ng-disabled="vm.noAvailableSkills || !vm.selectedSkill">{{ (vm.activeSkill ? 'general.Save' : 'general.Add') | translate }}</button>
                    </li>
                    <li>
                        <button class="btn bordered02" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="modal-body">
            <div class="form" ng-if="!vm.noAvailableSkills">
                <div class="row row-wide" ng-class="{'has-error': vm.form.errors.skillId}">
                    <label class="label w100p">{{ 'user.Skill name' | translate }}</label>
                    <div class="items w100p">
                        <ui-select ng-model="vm.selectedSkill"
                            theme="selectize"
                            on-select="vm.onSkillChange()"
                            title="{{ 'user.Choose skill' | translate }}">
                            <ui-select-match placeholder="{{ 'user.Select or search a skill in the list...' | translate }}">
                                {{vm.getSkillName($select.selected)}}
                            </ui-select-match>
                            <ui-select-choices repeat="skill in vm.skills | filter: {searchName: $select.search}">
                                <span ng-bind-html="vm.getSkillName(skill) | highlight: $select.search"></span>
                            </ui-select-choices>
                        </ui-select>
                        <p class="error" ng-if="vm.form.errors.skillId">{{ vm.form.errors.skillId }}</p>
                    </div>
                </div>
                <div class="row row-wide" ng-class="{'has-error': vm.form.errors.requiredProficiencyId}">
                    <label class="label w100p">{{ 'skill.Required proficiency' | translate }}</label>
                    <div class="items w100p">
                        <select class="form-control wide"
                            ng-model="vm.form.model.requiredProficiencyId"
                            ng-options="p.id as (p.points + ' - ' + vm.getProfieincyValue(p)) for p in vm.selectedSkill.scale.proficiencies"
                            ng-disabled="vm.selectedSkill && vm.selectedSkill.requiredProficiencyId && vm.form.model.requiredProficiencyId">
                        </select>
                        <p class="error" ng-if="vm.form.errors.requiredProficiencyId">{{ vm.form.errors.requiredProficiencyId }}</p>
                    </div>
                </div>
                <div class="row row-wide" ng-class="{'has-error': vm.form.errors.proficiencyId}">
                    <label class="label w100p ">{{ 'skill.Proficiency' | translate }}</label>
                    <div class="items w100p">
                        <select class="form-control wide"
                                ng-model="vm.form.model.proficiencyId"
                                ng-options="p.id as (p.points + ' - ' + vm.getProfieincyValue(p)) for p in vm.selectedSkill.scale.proficiencies">
                        </select>
                        <p class="error" ng-if="vm.form.errors.proficiencyId">{{ vm.form.errors.proficiencyId }}</p>
                    </div>
                    <p class="note">{{ vm.getSkillExplanation(vm.selectedSkill, vm.form.model.proficiencyId) }}</p>
                </div>
            </div>

            <!-- Message when no skills available -->
            <div class="no-skills flex flex-col items-center justify-center py-10 text-center" ng-if="vm.noAvailableSkills" style="padding: 40px 0;">
                <h3 style="font-size: 18px; font-weight: 600; margin-bottom: 6px;">{{ 'skill.No available skills' | translate }}</h3>
                <p style="color: #666; font-size: 14px; max-width: 320px;">
                    {{ 'skill.All available skills are already assigned to this user' | translate }}
                </p>
            </div>

            <ul class="actions01" ng-if="vm.activeSkill">
                <li class="primary">
                    <a
                     ng-click="vm.delete(vm.activeSkill)"
                     class="btn delete small"
                     ng-class="{disabled: vm.deleting}"
                     ng-attr-aria-disabled="{{vm.deleting ? 'true' : 'false'}}">{{ 'user.Remove skill' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (FormFactory, SkillResource, UserSkillResource, ModalService, I18nService, $translate) {
        this.FormFactory = FormFactory;
        this.SkillResource = SkillResource;
        this.UserSkillResource = UserSkillResource;
        this.ModalService = ModalService;
        this.I18nService = I18nService;
        this.$translate = $translate;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(new this.UserSkillResource(this.activeSkill));
        const expand = [
            'explanations.activeI18n,explanations.i18ns,explanations.proficiency',
            'scale,scale.scaleI18ns,scale.proficiencies.activeI18n,scale.proficiencies.skillProficiencyI18n',
            'activeI18n,i18ns'
        ].join(',');
        this.SkillResource.query({ expand, is_active: 1 }).$promise.then((skills) => {
            // Filter out user's existing skills except activeSkill
            this.skills = skills.filter(function (skill) {
                return !this.userSkills.some(function (userSkill) {
                    return userSkill.skillId === skill.id &&
                        (!this.activeSkill || skill.id !== this.activeSkill.skillId);
                }, this);
            }, this);

            // Filter proficiency i18ns by enabled scale languages
            this.skills.forEach(skill => {
                this.filterProficiencyI18nsByEnabledLanguages(skill);
            });

            // Add searchName property for ui-select filtering
            this.skills.forEach(skill => {
                skill.searchName = this.getSkillName(skill);
            });

            // Handle case when no available skills left
            this.noAvailableSkills = !this.activeSkill && this.skills.length === 0;

            if (this.activeSkill) {
                this.selectedSkill = skills.find(skill => skill.id === this.activeSkill.skillId);
                this.form.model.skillId = this.activeSkill.skillId;

                this.form.model.requiredProficiencyId = this.activeSkill.requiredProficiencyId;
                this.form.model.proficiencyId = this.activeSkill.proficiencyId;
            }
        });
    }

    getSkillExplanation (skill, proficiencyId) {
        if (!skill || !Array.isArray(skill.explanations)) return null;

        const explanation = skill.explanations.find(
            e => e.proficiencyId === proficiencyId
        );

        if (!explanation || !explanation.i18ns) return null;

        const explanationI18n = this.I18nService.getPreferredI18n(explanation.i18ns);

        if (explanationI18n && explanationI18n.value) {
            return `${explanation.proficiency.points} - ${explanationI18n.value}`;
        }

        return null;
    }

    getSkillName (skill) {
        if (!skill || !skill.i18ns) {
            return '';
        }

        const i18n = this.I18nService.getPreferredI18n(skill.i18ns);

        if (!i18n || !i18n.name) {
            return 'no translation';
        }
        return i18n.name;
    }

    onSkillChange () {
        this.form.errors = {};
        if (this.selectedSkill && this.selectedSkill.id) {
            this.form.model.skillId = this.selectedSkill.id;
            this.setProficiency();
        }
    }

    setProficiency () {
        if (this.selectedSkill.requiredProficiencyId) {
            this.form.model.requiredProficiencyId = this.selectedSkill.requiredProficiencyId;
        }

        const profs = this.selectedSkill && this.selectedSkill.scale && this.selectedSkill.scale.proficiencies;
        if (profs && profs.length > 0) {
            if (!this.form.model.requiredProficiencyId) {
                this.form.model.requiredProficiencyId = profs[0].id;
            }
            this.form.model.proficiencyId = profs[0].id;
        }
    }

    getProfieincyValue (item) {
        const i18n = this.I18nService.getPreferredI18n(item.skillProficiencyI18n);

        if (!i18n || !i18n.value) {
            return 'no translation';
        }
        return i18n.value;
    }

    filterProficiencyI18nsByEnabledLanguages (skill) {
        if (!skill || !skill.scale) return;

        // Get enabled languages from the scale
        const enabledLanguages = {};
        if (skill.scale.scaleI18ns) {
            Object.keys(skill.scale.scaleI18ns).forEach(lang => {
                const i18n = skill.scale.scaleI18ns[lang];
                if (i18n && i18n.isEnabled) {
                    enabledLanguages[lang] = true;
                }
            });
        }

        // Filter proficiency translations to only include enabled languages
        const proficiencies = skill.scale.proficiencies || [];
        proficiencies.forEach(p => {
            if (!p.skillProficiencyI18n) return;

            const filteredI18ns = {};
            Object.keys(p.skillProficiencyI18n).forEach(lang => {
                if (enabledLanguages[lang]) {
                    filteredI18ns[lang] = p.skillProficiencyI18n[lang];
                }
            });
            p.skillProficiencyI18n = filteredI18ns;
        });

        // Filter explanation translations to only include enabled languages
        const explanations = skill.explanations || [];
        explanations.forEach(e => {
            if (!e.i18ns) return;

            const filteredI18ns = {};
            Object.keys(e.i18ns).forEach(lang => {
                if (enabledLanguages[lang]) {
                    filteredI18ns[lang] = e.i18ns[lang];
                }
            });
            e.i18ns = filteredI18ns;
        });
    }

    save () {
        if (this.noAvailableSkills) {
            return;
        }
        this.form.model.userId = this.user.id;
        this.form.save().then(() => {
            this.onUpdate();
        });
    }

    delete (item) {
        if (this.deleting) return;
        if (!item || !item.id) return;

        const msg = this.$translate.instant('skill.Are you sure you want to remove this skill from the user?');
        this.ModalService.confirm(msg)
            .then(() => {
                this.deleting = true;
                return this.UserSkillResource.delete({ id: item.id }).$promise;
            })
            .then(() => this.onUpdate())
            .finally(() => {
                this.deleting = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/user/addSkill/index.js